var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V16H496V176H16Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V176H496V336H16Z",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V336H496V496H16Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 268.277C292.509 268.277 322.105 234.33 322.105 192.454C322.105 150.579 292.509 116.632 256 116.632C219.491 116.632 189.895 150.579 189.895 192.454C189.895 234.33 219.491 268.277 256 268.277Z",
    fill: "#C0392B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M486.598 175.997H25.4016V293.551H486.598V175.997Z",
    fill: "#C0392B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256 72.5488C253.745 72.5488 252.925 76.4281 252.925 80.1899C252.925 89.5942 253.95 94.2964 256 107.815C258.091 94.2964 259.075 89.4767 259.075 80.1899C259.075 76.3106 258.05 72.5488 256 72.5488Z",
    fill: "#C0392B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 168H16V178H496V168Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/MW.ca971e306e5793c89315abbc0b8a5fd8.svg";
export { ForwardRef as ReactComponent };